import React from "react";
import { Provider } from "mobx-react";
import { ApolloProvider } from "react-apollo";
import { ThemeProvider } from "emotion-theming";
import { generateTheme } from "@styles";
import { ErrorBoundary } from "@utils";
import { Settings, apolloClient } from "@services";
import { FlipgiveStore } from "@stores";
import { StoreAppProvider } from "@hooks";
import { OnboardingStepper } from "./OnboardingStepper";

interface IProps {
  campaignId: string;
  redirectUrl: string;
  currentUser: object;
  primaryColor: string;
  giftcardId: string;
}

export default (props: IProps) => {
  const {
    campaignId,
    environment,
    incentiveAvailable,
    incentiveAmount,
    incentiveTimeLeft,
    primaryColor,
    featureFlags,
    currency,
    currentUser,
    fundraiserId,
    isMember,
    isOwner,
    isContinuity,
    stripeKey,
    mapLocation,
    siteName,
    isVoucher,
    isPartnerSite,
    fundingUrl,
    isMobile
  } = props;

  const { giftcardId } = props;
  const theme = generateTheme({ primary: primaryColor });
  Settings.setDefaultsFromProps(props);

  FlipgiveStore.setCurrentUser(props.currentUser);
  FlipgiveStore.setCampaignId(props.campaignId);

  const initialState = {
    featureFlags,
    campaignId,
    environment,
    incentiveAvailable,
    incentiveAmount,
    incentiveTimeLeft,
    currency,
    currentUser,
    fundraiserId,
    isMember,
    isOwner,
    isContinuity,
    stripeKey,
    mapLocation,
    theme,
    siteName,
    isPartnerSite,
  };
  const client = apolloClient(Settings.apiUrl);
  return (
    <ErrorBoundary>
      <ApolloProvider client={client}>
        <Provider FlipgiveStore={FlipgiveStore}>
          <StoreAppProvider initialState={initialState}>
            <ThemeProvider theme={theme}>
              <OnboardingStepper 
                fundingUrl={fundingUrl}
                isMobile={isMobile}
              />
            </ThemeProvider>
          </StoreAppProvider>
        </Provider>
      </ApolloProvider>
    </ErrorBoundary>
  );
};
